export default __webpack_public_path__ + "static/media/deletedStamp.68459906.png";